
import React from 'react';
import { CONFIG } from '../constants';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton: React.FC = () => {
  const message = encodeURIComponent("Hello, I'm interested in a legal consultation with the Law Offices of Akil Tirana, Esq.");
  const url = `https://wa.me/${CONFIG.whatsappNumber}?text=${message}`;

  return (
    <a 
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-8 right-8 z-[100] group flex items-center"
      aria-label="Contact on WhatsApp"
    >
      <div className="bg-white text-gray-900 px-4 py-2 rounded-full shadow-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 mr-3 text-xs font-bold tracking-widest uppercase pointer-events-none border border-gray-100">
        WhatsApp Us
      </div>
      <div className="relative">
        <div className="absolute inset-0 bg-green-500 rounded-full animate-custom-pulse scale-110 opacity-50"></div>
        <div className="relative bg-[#25D366] text-white p-4 rounded-full shadow-2xl hover:scale-110 transition-transform duration-300">
          <MessageCircle className="w-7 h-7" fill="white" />
        </div>
      </div>
    </a>
  );
};

export default WhatsAppButton;
